export default __webpack_public_path__ + "static/media/envelope-fill.7f922cc3.svg";